import { render, staticRenderFns } from "./IcoBack.vue?vue&type=template&id=0fba3140&lang=html"
import script from "./IcoBack.vue?vue&type=script&lang=js"
export * from "./IcoBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports